import React from "react";
import "./Aboutus.css";
import youtubelogo from "../../assets/youtubelogo.png";
import burststar from "../../assets/Burst-star.png";
import visionimg from "../../assets/visionimg.png";
import ourvisionimg from "../../assets/ourvisionimg.png";
import ourmissionimg from "../../assets/ourmissionimg.png";
import backgroundimg1 from "../../assets/backgroundimg1.png";
import rightcircle from "../../assets/rightcircle.png";
import rightarrow from "../../assets/rightarrow.png";
import leftcircle from "../../assets/leftcircle.png";
import leftarrow from "../../assets/leftarrow.png";
import linkedinlogo from "../../assets/linkedinlogo.png";
import linkedinimg1 from "../../assets/linkedinimg1.png";
import linkedinimg2 from "../../assets/linkedinimg2.png";
import linkedinimg3 from "../../assets/linkedinimg3.png";
import linkedinimg4 from "../../assets/linkedinimg4.png";
import linkedinimg5 from "../../assets/linkedinimg5.png";
import linkedinimg6 from "../../assets/linkedinimg6.png";
import linkedinimg7 from "../../assets/linkedinimg7.png";
import linkedinimg8 from "../../assets/linkedinimg8.png";
import linkedinimg9 from "../../assets/linkedinimg9.png";
import linkedinimg10 from "../../assets/linkedinimg10.png";
import linkedinimg11 from "../../assets/linkedinimg11.png";
import linkedinimg12 from "../../assets/linkedinimg12.png";
import linkedinimg13 from "../../assets/linkedinimg13.png";
import linkedinimg14 from "../../assets/linkedinimg14.png";
import linkedinimg15 from "../../assets/linkedinimg15.png";
import linkedinimg16 from "../../assets/linkedinimg16.png";
import linkedinimg17 from "../../assets/linkedinimg17.png";
import linkedinimg18 from "../../assets/linkedinimg18.png";
import growthimg1 from "../../assets/growthimg1.png";
import growthimg2 from "../../assets/growthimg2.png";
import growthimg3 from "../../assets/growthimg3.png";
import growthimg4 from "../../assets/growthimg4.png";
import joinushandsimg from "../../assets/joinushandsimg.png";
import curlyarrow from "../../assets/curlyarrow.jpg";
import curlyarrow2 from "../../assets/curlyarrow2.png";

const Aboutus = () => {
  return (
    <>
      <div className="about-us-main-body">
        <div className="about-us-body">
          <div>
            <p className="about-us-text">About us</p>
          </div>
          <div>
            <p className="we-are-text">We are South Asia’s largest</p>
          </div>
          <div>
            <p className="higher-text">
              higher EdTech company. With the latest technology, pedagogy,
              industry partners and world-class faculty, we create immersive
              online learning experiences for our learners globally.
            </p>
          </div>
          <div className="watch-btn-body">
            <button className="watch-btn">
              Watch glimpses of impact we have created!
            </button>
          </div>
        </div>
        <div>
          <img src={youtubelogo} alt="" className="youtube-logo" />
        </div>
      </div>



      
    <div className="we-think-main-body">
      <div className="we-think-body">
        <div className="about-startext">
        <div>
          <img src={burststar} alt="" className="burst-star-img" />
        </div>
        <div>
          <p className="we-think-text">WE THINK EDUCATION DIFFERENTLY</p>
        </div>
        </div>
        
        <div className="about-startext">
        <div>
          <img src={burststar} alt="" className="burst-star-img" />
        </div>
        <div>
          <p className="we-think-text">WE POWER CARRES GLOBALLY</p>
        </div>
        </div>
        
        <div className="about-startext">
        <div>
          <img src={burststar} alt="" className="burst-star-img" />
        </div>
        <div>
          <p className="we-think-text">WE THINK ED</p>
        </div>
        </div>
        
      </div>
      </div>




   <div className="our-vision-main-bodyy">
      <div className="our-vision-main-body">
        <div className="our-vision-body">
          <div className="our-vision-text-body">
            
              <img src={visionimg} alt="" className="vision-img" />
            
            <div>
              <label className="our-vision-text">Our vision</label>
            </div>
          </div>
          <div className="powering-text-body">
            <p className="powering-text">
              Powering career success for every member of the global
              workforce as their trusted lifelong learning partner.
            </p>
          </div>
        </div>
        <div>
          <img src={ourvisionimg} alt="" className="our-vision-img" />
        </div>
      </div>

      <div className="our-vision-main-body1">
        <div>
          <img src={ourmissionimg} alt="" className="our-vision-img" />
        </div>
        <div className="our-vision-body">
          <div className="our-vision-text-body">
            <div>
              <img src={visionimg} alt="" className="vision-img" />
            </div>
            <div>
              <label className="our-vision-text">Our mission</label>
            </div>
          </div>
          <div className="powering-text-body">
            <p className="powering-text">
              Making our learners achieve their desired outcomes.
            </p>
          </div>
        </div>
      </div>
      </div>

      <div className="beginning-body">
        <div className="begining-text-body">
          <p className="beginning-text">Beginning of a revolution</p>
          <p className="back-in-text">
            Back in 2015, our founders noticed that the rapidly evolving
            industry required professionals to continuously upskill themselves
            as learning for professionals comes to a halt after entering a
            working space. This was when upGrad was formed to impact the lives
            of working professionals by helping them upskill while they
            work. With an endeavour to facilitate quality education to the
            future workforce through our UG and PG programs, we continue to
            build online learning  as interactive as a classroom setup.
          </p>
        </div>
      </div>

      <div className="a-journey-text-body">
        <div>
          <p className="a-journey-text">A journey as dynamic as us</p>
        </div>


          <div className="manufacturing-body">
            <div className="our-found-main-body">
              <div className="turn-first-bodyy">
                <div className="turn-body">
                  <p className="turn-textt">2015</p>
                </div>
                <div className="we-body ">
                  <p className="we-textt">
                    Our Founding Team, Ronnie, Mayank and Phalgun came together
                    and laid the cornerstone of upGrad on 23 March, 2015
                  </p>
                </div>
              </div>
              <img src={curlyarrow2} alt="" className="curly-arrow-about"/>
            </div>
            
          </div>

          <div className="manufacturing-body">
            <div className="turn-mainn-body">
            <img src={curlyarrow} alt="" className="curly-arrow-about"/>
              <div className="turn-firstt-bodyy">
                <div className="turn-body">
                  <p className="turn-textt">2016</p>
                </div>
                <div className="we-body ">
                  <p className="we-textt">
                    Hruthi AI Tech Hub 1st batch of 114 learners graduated after
                    completing our 1st program in Entrepreneurship, "Startup
                    with Hruthi AI Tech Hub"
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="manufacturing-body">
            <div className="our-found-main-body">
              <div className="turn-first-bodyy">
                <div className="turn-body">
                  <p className="turn-textt">2018</p>
                </div>
                <div className="we-body ">
                  <p className="we-textt">
                    Touched a learner base of 10,000+ learners and crossed 450+
                    successful career transitions
                  </p>
                </div>
              </div>
              <img src={curlyarrow2} alt="" className="curly-arrow-about"/>
            </div>
             </div>

          <div className="manufacturing-body">
            
            <div className="turn-mainn-body">
            <img src={curlyarrow} alt="" className="curly-arrow-about"/>
              <div className="turn-firstt-bodyy">
                <div className="turn-body">
                  <p className="turn-textt">2019</p>
                </div>
                <div className="we-body ">
                  <p className="we-textt">
                    Became India's largest online higher education company with
                    the highest gross revenue in the Indian Market
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="manufacturing-body">
            <div className="our-found-main-body">
              <div className="turn-first-bodyy">
                <div className="turn-body">
                  <p className="turn-textt">2020</p>
                </div> 
                <div className="we-body ">
                  <p className="we-textt">
                    Crossed 1M+ registered learners; Launched upGrad Degrees,
                    upGrad Rekrut, upGrad Study Abroad
                  </p>
                </div>
              </div>
              <img src={curlyarrow2} alt="" className="curly-arrow-about"/>
            </div>
            
            
          </div>

          <div className="manufacturing-body">
            <div className="turn-mainn-body">
              <div className="turn-firstt-bodyy">
                <div className="turn-body">
                  <p className="turn-textt">2021</p>
                </div>
                <div className="we-body ">
                  <p className="we-textt">
                    Became a Unicorn with a valuation of $1.2 B; Expanded to
                    North America, Europe, Middle East & the Asia Pacific;
                    Completed 3 more M&As; Touched 2M+ registered learners
                    across 100 countries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div>
        <p className="our-corporate-text">Our Corporate Leadership Team</p>
      </div>

      <div className="linkedin-main-bodyy">
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg1} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Jane Cooper</p>
          </div>
          <div>
            <p className="co-founder-text ">Co-Founder and Chairman</p>
          </div>
          <div>
            <p className="one-of-the-text">
              One of the '25 Asia’s Most Powerful People,' by Fortune Magazine
            </p>
          </div>
        </div>
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg2} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Jane Cooper</p>
          </div>
          <div>
            <p className="co-founder-text ">Co-Founder and MD</p>
          </div>
          <div>
            <p className="one-of-the-text">
              BW Education '40 under 40' Achiever by Business World, 2020
            </p>
          </div>
        </div>
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg3} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Wade Warren</p>
          </div>
          <div>
            <p className="co-founder-text ">Co-Founder and Chairman</p>
          </div>
          <div>
            <p className="one-of-the-text">
              BW Disrupt '40 under 40' Achiever’ by Business World, 2020
            </p>
          </div>
        </div>
      </div>
      <div className="linkedin-main-bodyy">
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg4} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Cameron Williamson</p>
          </div>
          <div>
            <p className="co-founder-text">Chief Finance Officer</p>
          </div>
        </div>
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg5} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Chief Finance Officer</p>
          </div>
          <div>
            <p className="co-founder-text">Chief Human Resource Officer</p>
          </div>
        </div>
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg6} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Leslie Alexander</p>
          </div>
          <div>
            <p className="co-founder-text">President – M&A</p>
          </div>
        </div>
      </div>
      <div className="linkedin-main-bodyy">
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg7} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Robert Fox</p>
          </div>
          <div>
            <p className="co-founder-text">President - Legal</p>
          </div>
        </div>
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg8} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Jacob Jones</p>
          </div>
          <div>
            <p className="co-founder-text">President - Tech & Product</p>
          </div>
        </div>
        <div className="linkedin-main-body">
          <div className="linkedin-body">
            <div>
              <img src={linkedinlogo} alt="" className="linkedin-logo" />
            </div>
            <div>
              <label className="linkedin-profile-text">LinkedIn Profile</label>
            </div>
          </div>
          <div className="linkedin-img-body">
            <img src={linkedinimg9} alt="" className="linkedin-img1" />
          </div>
          <div>
            <p className="jane-cooper-text">Darlene Robertson</p>
          </div>
          <div>
            <p className="co-founder-text">President</p>
          </div>
        </div>
      </div>

      <div className="consumer-text-main-body">

          <p className="our-corporate-text">Consumer - Leadership Team</p>


        <div className="linkedin-main-bodyy">
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg10} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Kathryn Murphy</p>
            </div>
            <div>
              <p className="co-founder-text">CEO – International & GSP</p>
            </div>
          </div>
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg11} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Arlene McCoy</p>
            </div>
            <div>
              <p className="co-founder-text">
                President - Working Professional (India)
              </p>
            </div>
          </div>
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg12} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Kathryn Murphy</p>
            </div>
            <div>
              <p className="co-founder-text ">CEO – International & GSP</p>
            </div>
          </div>
        </div>
        <div className="linkedin-main-bodyy">
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg13} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Courtney Henry</p>
            </div>
            <div>
              <p className="co-founder-text ">President - Degrees</p>
            </div>
          </div>
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg14} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Jerome Bell</p>
            </div>
            <div>
              <p className="co-founder-text ">President - Study Abroad</p>
            </div>
          </div>
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg15} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Marvin McKinney</p>
            </div>
            <div>
              <p className="co-founder-text ">President - Offline Business</p>
            </div>
          </div>
        </div>

        <div>
          <p className="our-corporate-text">Enterprise</p>
        </div>
        <div className="enterprise-body">
          <div className="linkedin-mainn-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg16} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Eleanor Pena</p>
            </div>
            <div>
              <p className="co-founder-text ">
                Chief Executive Officer - Enterprise
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="placement-body">
        <div>
          <p className="our-corporate-text">Placements</p>
        </div>
        <div className="linkedin-mainn-bodyy">
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg17} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Eleanor Pena</p>
            </div>
            <div>
              <p className="co-founder-text ">President</p>
            </div>
          </div>
          <div className="linkedin-main-body">
            <div className="linkedin-body">
              <div>
                <img src={linkedinlogo} alt="" className="linkedin-logo" />
              </div>
              <div>
                <label className="linkedin-profile-text">
                  LinkedIn Profile
                </label>
              </div>
            </div>
            <div className="linkedin-img-body">
              <img src={linkedinimg18} alt="" className="linkedin-img1" />
            </div>
            <div>
              <p className="jane-cooper-text">Arlene McCoy</p>
            </div>
            <div>
              <p className="co-founder-text ">President</p>
            </div>
          </div>
        </div>
      </div>

      <div className="consumer-text-main-body">
        <div>
          <p className="our-corporate-text">Growth - the constant we admire!</p>
        </div>

        <div className="growth-main-bodyy">
          <div className="growth-main-body">
            <div className="growth-img-main-body">
            <div className="growth-img-body">
              <img src={growthimg1} alt="" className="growth-img" />
            </div>
            </div>
            <div>
              <p className="entered-text">Entered the Unicorn Club</p>
            </div>
            <div>
              <p className="raised-text">
                Raised funding from IFC, IIFL & Teamsek and
              </p>
            </div>
          </div>
          <div className="growth-main-body">
            <div className="growth-img-main-body">
            <div className="growth-img-body">
              <img src={growthimg2} alt="" className="growth-img" />
            </div>
            </div>
            <div>
              <p className="entered-text">Entered the Unicorn Club</p>
            </div>
            <div>
              <p className="raised-text">
                Raised funding from IFC, IIFL & Teamsek and
              </p>
            </div>
          </div>
          <div className="growth-main-body">
            <div className="growth-img-main-body">
            <div className="growth-img-body">
              <img src={growthimg3} alt="" className="growth-img" />
            </div>
            </div>
            <div>
              <p className="entered-text">Entered the Unicorn Club</p>
            </div>
            <div>
              <p className="raised-text">
                Raised funding from IFC, IIFL & Teamsek and
              </p>
            </div>
          </div>
          <div className="growth-main-body">
            <div className="growth-img-main-body">
            <div className="growth-img-body">
              <img src={growthimg4} alt="" className="growth-img" />
            </div>
            </div>
            <div>
              <p className="entered-text">Entered the Unicorn Club</p>
            </div>
            <div>
              <p className="raised-text">
                Raised funding from IFC, IIFL & Teamsek and
              </p>
            </div>
          </div>
        </div>

      <div className="join-us-main-body">
        <div className="join-us-body">
          <div className="join-us-text-body">
            <p className="join-us-text">Join Us In Changing Lives</p>
          </div>
          <div className="watch-btn-body">
            <button className="watch-btn">Find A Role You Love!</button>
          </div>
          </div>

          <img src={joinushandsimg} alt="" className="join-us-hands-img"/>

        
        
        </div>

      </div>
    </>
  );
};

export default Aboutus;
